<template>
  <path
    d="M10 5.50024C10 6.33024 10.67 7.00024 11.5 7.00024H12.21L8.79 15.0002H7.5C6.67 15.0002 6 15.6702 6 16.5002C6 17.3302 6.67 18.0002 7.5 18.0002H12.5C13.33 18.0002 14 17.3302 14 16.5002C14 15.6702 13.33 15.0002 12.5 15.0002H11.79L15.21 7.00024H16.5C17.33 7.00024 18 6.33024 18 5.50024C18 4.67024 17.33 4.00024 16.5 4.00024H11.5C10.67 4.00024 10 4.67024 10 5.50024Z"
  />
</template>
